/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Escalation workflow status
 * @export
 * @interface EscalationStatusResponse
 */
export interface EscalationStatusResponse {
    /**
     * Current tier (1-based)
     * @type {number}
     * @memberof EscalationStatusResponse
     */
    currentTier?: number;
    /**
     * Total number of tiers
     * @type {number}
     * @memberof EscalationStatusResponse
     */
    totalTiers?: number;
    /**
     * Status: RUNNING, ACKNOWLEDGED, COMPLETED, FAILED
     * @type {string}
     * @memberof EscalationStatusResponse
     */
    status?: string;
    /**
     * User who acknowledged (if status is ACKNOWLEDGED)
     * @type {string}
     * @memberof EscalationStatusResponse
     */
    acknowledgedBy?: string;
    /**
     * Epoch millis when escalation was acknowledged (for audit trail)
     * @type {number}
     * @memberof EscalationStatusResponse
     */
    escalationTimestamp?: number;
    /**
     * Error message if any
     * @type {string}
     * @memberof EscalationStatusResponse
     */
    error?: string;
}

/**
 * Check if a given object implements the EscalationStatusResponse interface.
 */
export function instanceOfEscalationStatusResponse(value: object): value is EscalationStatusResponse {
    return true;
}

export function EscalationStatusResponseFromJSON(json: any): EscalationStatusResponse {
    return EscalationStatusResponseFromJSONTyped(json, false);
}

export function EscalationStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EscalationStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'currentTier': json['currentTier'] == null ? undefined : json['currentTier'],
        'totalTiers': json['totalTiers'] == null ? undefined : json['totalTiers'],
        'status': json['status'] == null ? undefined : json['status'],
        'acknowledgedBy': json['acknowledgedBy'] == null ? undefined : json['acknowledgedBy'],
        'escalationTimestamp': json['escalationTimestamp'] == null ? undefined : json['escalationTimestamp'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function EscalationStatusResponseToJSON(json: any): EscalationStatusResponse {
    return EscalationStatusResponseToJSONTyped(json, false);
}

export function EscalationStatusResponseToJSONTyped(value?: EscalationStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentTier': value['currentTier'],
        'totalTiers': value['totalTiers'],
        'status': value['status'],
        'acknowledgedBy': value['acknowledgedBy'],
        'escalationTimestamp': value['escalationTimestamp'],
        'error': value['error'],
    };
}

